import React, { Component } from 'react';
import { connect } from 'react-redux';
import Modal from '../../components/Modal';
import { unmarkAsDud } from '../../actions/ClientActions';

@connect(
    state => ({}),
    { unmarkAsDud }
)
export default class UnmarkAsDudModal extends Component {
    handleRestore() {
        this.props.unmarkAsDud(this.props.client.id);
    }
    render() {
        var actionButton = (<button className="btn btn-success" onClick={this.handleRestore.bind(this)}>Unmark as dud</button>);

        return (
            <Modal actionButton={actionButton} className="modal-success" title={"Confirm unmark as dud"}>
                <p>Are you sure?</p>
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./app/components/clients/UnmarkAsDudModal.js